// extracted by mini-css-extract-plugin
module.exports = {"buttonRow":"sharing-module--button-row--amMX6","sharingButton":"sharing-module--sharing-button--3OVhK"};